export const MODAL_DEACTIVATED = '@@mah-maps/MODAL_DEACTIVATED';